import { Component, Input, OnInit } from "@angular/core";
import { AdministrativeUnitSurveyMessage } from "src/app/shared/models/survey";

@Component({
    selector: "message",
    templateUrl: "./message.component.html",
    styleUrls: ["./message.component.scss"],
    standalone: false
})
export class MessageComponent implements OnInit {
  @Input() model: AdministrativeUnitSurveyMessage;

  constructor() {}

  ngOnInit(): void {}
}
